export const forhandsvarselVurderingUuidsAffectedByNotificationBug = [
  "65d4b02a-3141-45d2-9a3a-939f6a86a539", // this one line is dev test data
  "3f00c184-0467-4187-95dd-c692109be074",
  "456d6965-145b-484d-9511-23ca0477e666",
  "28caa030-6533-494a-848c-d4bc7f1db24d",
  "0cd62e17-aaf2-4c9e-a33b-7809971daeb9",
  "3747756f-6254-41b9-a8bd-1d620fb3a024",
  "51b693fb-f790-4b0b-9c8e-bee71b79abc0",
  "34e379ff-a71e-4755-9a09-0e89355b2b4d",
  "c323edb5-452d-4f2e-b030-1635a80f3054",
  "34a40a20-13af-4d1f-9459-936a84bca85d",
  "b592b6d4-0868-44ac-940b-70716e8ca33f",
  "ca7cf344-fb53-42e1-ae24-4a8044186902",
  "43ee6ed6-33d8-4e01-834c-72a01a9b5e2d",
  "2f6a71c8-cf46-4e02-b99e-6d101b77d49c",
  "70a97008-53e8-4854-9a19-781a384421e4",
  "4c481e32-2dde-4c65-989a-6cf0981b80ed",
  "bbb27bd0-22d0-4a03-925c-188f49889574",
  "1cc38245-e0f2-421f-b52f-c5cbf868b5e1",
  "92c57b62-98a3-46f1-b29f-cf08f2e90b3f",
  "cda412ad-0110-4dcc-a6fc-fd7b720a25f6",
  "0a9493f1-d362-4787-ac65-762d0acc351c",
  "7349a8bc-e754-40f7-a27e-230ebecfd569",
  "01acca91-2442-4943-a781-e3cf09d54bd4",
  "ab453e9a-796c-42bc-87a8-f1b134758a3c",
  "506b960a-c34a-41bd-8b98-373a9165257d",
  "a852154d-1d7e-40b4-8c87-abf0f4fd01b6",
  "574f9bac-0636-4a13-8d96-f95943570fb0",
  "affdf422-da40-4fb0-93ff-72c2c22a1483",
  "f093e8eb-ed9f-4509-a58b-0acb162660b6",
  "6cc93d2b-b735-4577-adc5-6b537f19fb7a",
  "2a5c05cf-fe98-4dcf-9de8-b5adc4158747",
  "f2710d0f-5545-4fbd-b296-9564227dc44a",
  "1d89bf9a-fb31-4422-bd08-13ec05016fa7",
  "59564c64-9754-4c06-85f6-caef5b83821a",
  "50125452-d066-46d1-9204-2990a1eca715",
  "e0077a22-2ae2-4279-9554-b8ea9eeecd72",
  "403f72c7-acfd-4f2d-b818-bea1445ca336",
  "d36dfc45-67a0-45c0-8a0f-c8cec9e60adb",
  "532fe3c2-4362-42fc-a9d0-d69c5c715eca",
  "dadc4d46-6eba-45b8-806f-7c4dbf8503d5",
  "b4382cdd-4c8f-4d71-af5c-8a9ce996a3a9",
  "b8a7adc0-c43e-4565-95b3-a5d57f7efb74",
  "976a6243-35d0-43b0-995b-bb07aae0f76b",
  "fd13bc45-443b-4aaf-b75c-c128e6191331",
  "3b914caa-26ef-4fd7-b420-7da1f1bafbe0",
  "5cbdc2e2-40ba-44a5-bad5-da6472ea9f89",
  "3bbb22f4-618d-4b1d-b850-37e644c521da",
  "0ff75269-8abc-498b-9498-98616c5371f3",
  "9141e61b-f308-4f06-bc75-b3d011af9969",
  "9427fc12-004f-41f0-9003-e53e930b5015",
  "dbe57edf-cbbe-4b9e-ac03-3c98ebec1a50",
  "99e1e277-b352-40b7-8173-0d49bd8b8627",
  "9a7c7e3c-4075-4e87-b533-b7863048d95a",
  "39652b5a-7ff5-48f5-bc8f-07691cba1465",
  "364632ba-694a-42ed-8f78-ad855690bf00",
  "cc91adfc-6665-414a-8f20-f418713f95c9",
  "a56a3626-5b7f-4cc5-9936-88ebeffb9f68",
  "0e5ac59a-734e-4333-ab9a-265d76bf73cf",
  "fd03066d-6c82-4663-a61f-2ec148d0d417",
  "8c798566-25aa-4f7c-a11b-7a32b5e6528e",
  "fc67ac42-973a-4776-b123-1b9e09075f29",
  "4f73de2e-c42f-4b26-ac2b-3cb991f92617",
  "ebc2df47-cab1-453f-8bd0-54a70078ae84",
  "b7a9bb02-91e6-4100-ad61-50c0d0785d75",
  "417293ae-0e01-439b-ab00-51c0536ce298",
  "b61cd30c-425c-4a13-8f9d-b678129bec87",
  "ee62d1fb-e531-4861-9296-bce5a4f050ae",
  "3927c548-fb44-4de2-8247-b3ee2fd39083",
  "3660ccb8-725a-40e0-913d-d7bda181673a",
  "ded671c5-ffa2-460d-9592-487d9d49121a",
  "04ee7dfb-8198-4817-9a98-51a304252c09",
  "32dcd1d4-3cd9-4418-aad2-928fcb927e55",
  "0df3333a-60df-432a-926a-addfad4771e2",
  "5a5b8ce9-28c5-40a9-b6ed-168200e24b22",
  "27714f9a-fcd4-4e84-9f3b-8976207d2ded",
  "0a5e6b98-0358-49a9-83d4-1b936a66f032",
  "06092626-ebd2-4ea7-bc7d-421cb1817852",
  "f12f48a7-56d0-4e22-9952-784495e47a8a",
  "81d7c48d-0ac2-4c95-9bc6-878df800240f",
  "8722c238-4c98-4de3-92ac-88b1e4e03cb7",
  "83551837-9f58-4c51-a007-4acc769e7b4f",
  "6c620a94-1a09-49de-b0a0-daecfc8f92df",
  "4666ef35-7b3b-4e90-95bf-8826c70b5138",
  "f10c8e70-e3ca-4ea3-9aed-73a61751db8e",
  "860e50b4-d3f3-4dcd-a143-cb61a9e1402c",
  "266d42a3-a5bd-423e-9108-7058f4e3ff41",
  "dbd0662b-307c-4185-85e5-ea11cb5789d9",
  "d6f629ac-4aff-4d1e-b17b-021694a2060c",
  "73f3b9f9-3542-4785-828b-ff3d39d72380",
  "63c14381-a8b2-42f7-aab2-7faa9c514ef9",
  "905b0770-6ac0-441d-a06d-cd6b615e27ff",
  "88264821-5d9d-4343-8d0b-9946f15806b5",
  "b1df857c-8b5b-4aad-8ed4-8f62f1597fa3",
  "8803aa2a-3394-4bcd-ab67-cbd14d819f5a",
  "f779814a-bc83-4732-8950-61b8ce5175d4",
  "2cd3f66a-6a67-41f3-beb1-dc63a325b967",
  "83308a2d-c518-4987-9b22-8b903e1b42f7",
  "48e8d891-032b-4da7-abde-1bdf5d202e23",
  "3844bc9e-e1ff-4fc8-b592-9c1f008058e9",
  "ea1cdda5-2884-4c31-9be4-83c9bbcaa0e3",
  "67c31415-b97b-4c51-8529-7fd2aa3bb362",
  "98bd7ac5-df75-44bf-a3b1-1b3d5e0b0501",
  "d5fad6ec-d356-4e8b-b60b-6ad626023bfd",
  "a7785491-9671-44a6-a9b9-6470fb731ad4",
  "fbcd53b0-5927-4122-8eb1-8b24aae5bfc6",
  "e2245e53-6fae-4559-a4e9-9d512d91c727",
  "ba83abc8-ead3-4b0d-b1d3-488061ebc1f8",
  "36aa4e1d-817a-48c8-a769-7de4ae74b300",
  "dff7c0ff-b76a-4855-83ab-b286434e45b0",
  "d5e5acd3-8798-4e2f-b5d5-a0fd763c5c5c",
  "9e1821f8-001f-466b-bfa5-a439bbba2763",
  "6440172e-762b-4413-a374-4eb6a2f759b2",
  "d63ae617-e1c0-4b89-a584-429775e1cbb7",
  "9c22aa7d-0379-49d0-a8e5-57d344438a65",
  "7208ac04-ac90-4319-bfaf-51b21c52df61",
  "e2901b01-4adc-4ae2-95d3-9528b37d09e2",
  "eea4dd5d-24c4-441c-a9f9-501b50a98b15",
  "1f143733-dc44-467c-8a2a-243293546ac1",
  "cf29012b-a262-4839-94ec-e15063390abc",
  "30c0916d-c1c0-4db5-b22d-095ee6e9eb82",
  "c3ea8acb-cb19-480d-a95f-342efaba54e9",
  "4620ae23-088d-49f4-8e07-a2a6a1473c14",
  "39279be0-5b99-4ab8-bc5f-456c0bbeb0f7",
  "1914f7a3-37e5-442d-86be-3d070f2c24c3",
  "a1dbcd23-663d-46d2-bc3f-ff10196d7c40",
  "03e7a9e4-b291-48d1-ab72-ea4c023be3e6",
  "6de7358e-8d5b-4ecb-8e96-c84c4a75e821",
  "31e0b6aa-0aba-4a0d-a876-6b75c4e16ee2",
  "83179382-7790-43ba-9e04-3bc425313eec",
  "c1daa169-5464-4dac-951a-d433d3dc6655",
  "85437d8a-f96b-44f2-b781-7c7bb34326e1",
  "300c03d9-93a3-498b-bac3-7e3ad202a9ad",
  "40f7632a-10cf-492d-bfd3-3f2a4f413b33",
  "62ec19a3-5cac-4a5a-8ecc-30dffe418817",
  "8aa4a41d-19e8-4d98-b900-fd698e5c52db",
  "921d469f-6c4c-4d5f-a296-8d4420a14eab",
  "63ba8361-8558-4ee7-9989-8d7c4d470f9a",
  "cca9e2eb-a77d-4b8d-aaec-2b7932504f10",
  "6febfeca-ec04-465e-a4f0-7c1de0e65c51",
  "bd6696e6-8afb-4e39-bd19-27ed295895f9",
  "9c827dae-b088-4831-98ed-9cba17c45287",
  "09b9fa9b-bdb8-46b2-8680-4fbcfa6b2549",
  "ee205704-a6ea-4424-b19e-5db7dd14d89c",
  "2be324b9-0ab8-4e3a-83a6-b733f5f706e1",
  "eba96b7e-9581-49f9-88d1-caf253a7fc22",
  "85181333-c607-4832-a224-db6fedd84e34",
  "729939ab-c2c7-4ad7-a8ce-1cabd26835c5",
  "d190f4ca-1090-4b79-b95f-11fe2d6211dc",
  "c9da40c1-2be0-471e-855b-7590b0eeef1a",
  "8359a78b-2535-4210-8d1f-629b9e6758dd",
  "6f4bf971-5376-4a0e-a547-58f16de133e1",
  "45371328-6468-4346-81be-7d36fe996b34",
  "1139b2c2-4af6-4454-bc4c-ba9829f89e20",
  "bedb1368-4286-4db0-9047-2fee0e9931bd",
  "7fa35ef8-0546-46ae-b35a-e08a60997bb2",
  "443f9303-c86b-40a6-b41d-823bd111ae51",
  "72806c9f-5e58-4606-bb0b-b296444e6e3c",
  "473b266c-f1d6-42c7-aaa4-a8e873356133",
  "8f6e9769-8c67-4f7f-8142-2fe6586914d6",
  "7c838620-6498-49af-8b97-ed0e31d52a3b",
  "84f3d238-4c6f-4c04-9676-654d198925c8",
  "b551be3e-2cfa-4279-add8-172554163d2d",
  "6f040065-77c1-4bad-b3a2-797c1af73400",
  "34d98a8b-ffc9-4620-be9d-dadfda276006",
  "7f2fb140-f0af-4f99-bbca-7d47d05f9957",
  "378df7c3-ddbd-4217-b9e7-1eb12cba1852",
  "a272abde-13df-4e38-b890-1b0892f1a63a",
  "460a1be5-55db-4488-bd3a-02ac5a6b9066",
  "67ac0eca-bbda-472c-812e-a41492598380",
  "e3f48600-6cdb-4e29-86cc-d8e8b9101bf7",
  "174174a6-3f50-4fda-8051-da9b5a9bb62a",
  "b8b3305f-7f0b-4b14-b1a0-43782674dba5",
  "39ef564a-318c-47bd-b14d-e9f7c1aa24f7",
  "8dfd936b-4cfa-40f3-8be3-80dedf39c44a",
  "280f094e-fd12-4d81-811e-171f173db151",
  "db04b73a-2722-4ba6-9721-5c1c0ee3d1d5",
  "74935711-6767-4dfc-b527-dd0edf951685",
  "3b186e31-d938-49c0-be4a-2c2ba391cfe9",
  "d77205c6-f4a2-4270-a119-4388fe0425d3",
  "6d889f4d-7b9b-4a4b-a584-d2374f9707a6",
  "095fcb46-6f8b-48bc-9d44-93547dde2dbe",
  "789218d0-ccb4-49ea-92e1-f330f16d027e",
  "26c766a5-c168-4efa-aa41-4fe970ed6c31",
  "b13c70ad-dae0-4622-97f8-850589d13e87",
  "462eadaf-98cb-4aa3-9f77-9b02cb42f5cb",
  "db1bde61-5ff9-4706-8206-0b592ef1ae7e",
  "1ac3cd52-6479-42b9-a190-4c7439a1ec41",
  "5f9eb2f4-3da5-4ba1-a97c-a9c492ff471f",
  "0c6a8c35-16eb-4490-8d45-a6d1b3bfa61e",
  "605806ad-2190-4c2d-93e9-e3a2246a0fec",
  "49246d61-adbc-41de-af18-63a2f390a915",
  "3c22d851-b71d-44f9-998e-5dfd8933d433",
  "00983a00-7a45-4a32-971b-3fbd4292b911",
  "fcd0d4b7-dff3-41ac-8bd8-599576fea897",
  "2b0a4c8f-f3a9-49b4-bdf1-cad1bc9a1679",
  "815d0f04-aee8-401d-9d04-8586b2d29e08",
  "85332420-3154-4939-9a4b-b108fc0e306b",
  "8f822650-6b09-491c-92fc-c227140377be",
  "d7189c1f-92cc-4200-a6bb-8d66fd7f9c3b",
  "dfad3871-b63f-4868-8a54-60a9dc32facb",
  "9713aa59-552f-4cbd-a662-cacc36db7944",
  "30220c87-a24c-47dd-b737-9080efd8c826",
  "634c37d7-e19f-4d82-b4d1-231d3a028942",
  "c855a483-1a16-4924-a729-8ebe35cc77e8",
  "26011e32-e1bf-4b05-9643-43b46d0e3ea9",
  "efd3678f-0e28-4636-a126-482908b8fd81",
  "c8693966-c2ee-455c-ad6b-f444e9b0b979",
  "984dbcce-adcf-4b1d-a1a9-62b205b88fc0",
  "ff476aa6-bb09-4a1a-a4a3-3df64f98d13b",
  "afa9f0e6-b107-4087-90a2-fa5e681b8ef2",
  "2b97f6f9-2cbf-44b4-9068-b15315b0f312",
  "d3ac68f4-f9fc-4238-b2ba-8d977cc31b12",
  "6a099a4a-a852-4318-8d88-f0d20a8e5eb6",
  "4e7223cb-ded0-4d35-8331-2828d713f687",
  "2d834cf4-7c2e-4728-abcb-0ec6a00a9597",
  "747b230e-87d8-48ab-994d-aa56a3a78141",
  "1afeb843-6fd4-486e-af1a-a716e2e9351d",
  "f3aa04de-a3e7-42b4-8a58-6293d7acb19d",
  "0447dccd-35e7-4dc7-bc44-71dea9ac90a3",
  "fee6c8a8-3453-4332-8305-407dfd53e158",
  "34516a23-c182-4240-a0df-d9ce10cf9a9b",
  "a4b26dc2-b34e-431d-9b1e-f755e48f3210",
  "1aa1866e-d26e-4644-8ed9-43af7eac60ff",
  "dff9d4e5-e350-4363-a6df-9a9e771a54b6",
  "127b1769-ad58-400c-bf14-caff982e9d3f",
  "f7dc184a-c805-49b4-81dd-a6cbaee52641",
  "2a9feed6-e538-4181-9b5e-413c6a57d82b",
  "3a59b818-65f9-4bd1-8921-f09cd468f44e",
  "8fe350ec-5658-468f-8c30-c2e050280568",
  "b94e8a29-c8f4-477c-b549-93813f0652e3",
  "1fc0c727-586c-47f6-b32f-3b354fcea071",
  "739798e1-3ec6-476f-8f4b-309bcfc40926",
  "1104abfc-dd39-4bdc-b41f-5f6bd63a9feb",
  "13dff6ee-fca5-4e8c-a1cf-99821acb6cdc",
  "9b86c3eb-01f6-4a22-be3c-07b684d5fe96",
  "3dacf299-4994-43ec-a187-7944d2d9b015",
  "f47789a3-e02d-4b55-8ba5-1235bad58c6f",
];
